import type { ConceptDef } from '../types';

export const sortLivingNonLiving: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-living-non-living',
  label: 'Sort Living vs Non-Living',
  category: 'Sorting',
  description: 'Hear "living" or "non-living"; tap an example.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'a living thing — animal', answer: '🐶 dog' },
      { say: 'a living thing — plant', answer: '🌳 tree' },
      { say: 'a living thing — flower', answer: '🌹 flower' },
      { say: 'a non-living thing — vehicle', answer: '🚗 car' },
      { say: 'a non-living thing — furniture', answer: '🪑 chair' },
      { say: 'a non-living thing — toy', answer: '⚽ ball' },
    ],
  },
};
